<template>
  <div class="d-discover-feed-entries-group">
    <p
      v-if="showRelativeDate"
      class="large space-right-2em"
    >
      {{ group.relativeDate | duiCapitalize }}
    </p>

    <DDiscoverFeedEntries
      :entries="entries"
      :is-user-signed-in="isUserSignedIn"
    />

    <button
      v-if="canExpand"
      class="show-more-button button-white-bordered"
      type="button"
      @click="expand()"
    >
      Show more +{{ moreEntriesCount }}
    </button>
  </div>
</template>

<script>
import DDiscoverFeedEntries from '@d-components/d-discover-feed/d-discover-feed-entries/d-discover-feed-entries.vue';

export default {
  components: {
    DDiscoverFeedEntries,
  },
  props: {
    group: {
      type: Object,
      required: true,
    },
    isExpanded: {
      type: Boolean,
      default: false,
    },
    isUserSignedIn: {
      type: Boolean,
      required: true,
    },
    numberOfEntries: {
      type: Number,
      default: 5,
    },
    showRelativeDate: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    vm: {
      isExpanded: false,
    },
  }),
  computed: {
    canExpand() {
      return (!this.isExpanded &&
        this.moreEntriesCount > 0 &&
        !this.vm.isExpanded);
    },
    entries() {
      if (this.isExpanded ||
        this.vm.isExpanded ||
        this.group.entries.length <= this.numberOfEntries) {
        return this.group.entries;
      }

      return this.group.entries.slice(0, this.numberOfEntries);
    },
    moreEntriesCount() {
      const moreCount = (this.group.entries.length - this.numberOfEntries);
      return (moreCount > 0) ? moreCount : 0;
    },
  },
  methods: {
    expand() {
      this.$set(this.vm, 'isExpanded', true);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.d-discover-feed-entries-group {
  margin-bottom: $_2em;

  .show-more-button {
    color: getColor($grey, dark);
    font-size: $font-size-sm;
    font-weight: normal;
    margin-bottom: $_2em;
    width: 100%;

    &:active {
      background-color: getColor($grey, fade);
    }
  }
}
</style>
